import React from "react";
import PropTypes from "prop-types";
import { Inbox } from "lucide-react";

const EmptyState = ({ actions, compact = false, description, icon: Icon = Inbox, title }) => (
  <section className={["wsm-empty-state", compact && "wsm-empty-state--compact"].filter(Boolean).join(" ")}>
    <span className="wsm-empty-state__icon"><Icon aria-hidden="true" /></span>
    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {actions && <div className="wsm-empty-state__actions">{actions}</div>}
  </section>
);

EmptyState.propTypes = {
  actions: PropTypes.node,
  compact: PropTypes.bool,
  description: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
};

export default EmptyState;
